import type { RouteRecordRaw } from 'vue-router';

/**
 * Rotas para o módulo de pipeline
 */
export const pipelineRoutes: Array<RouteRecordRaw> = [
  {
    path: 'meus-negocios',
    props: true,
    name: 'Deals',
    component: () => import('@/views/private/pipeline/index.vue'),
    children: [
      {
        path: ':pipelineName',
        props: true,
        name: 'KanbanBoard',
        component: () =>
          import('@/components/pipeline/KanbanBoard.component.vue'),
      },
    ],
  },
];
